import { withDefaults } from '@warp-drive/legacy/model/migration-support';

// API resource: tio-api app/resources/api/v1/tas_payment_assistance_record_resource.rb
// Registered from the systemic missing-schema audit (the #9130/#8988 class:
// an API-emittable JSON:API type the FE manifest never registered).
const TasPaymentAssistanceRecordSchema = withDefaults({
  type: 'tas-payment-assistance-record',
  fields: [
    { kind: 'attribute', name: 'tasApplicationId' },
    { kind: 'attribute', name: 'employeeId' },
    { kind: 'attribute', name: 'amount' },
    { kind: 'attribute', name: 'manner' },
    { kind: 'attribute', name: 'groupedApplicationSnapshot' },
    { kind: 'attribute', name: 'createdAt' },
    { kind: 'attribute', name: 'updatedAt' },
    { kind: 'attribute', name: 'createdBy' },
    { kind: 'attribute', name: 'updatedBy' },
    {
      kind: 'belongsTo',
      name: 'tasPayment',
      type: 'tas-payment',
      options: { async: false, inverse: null },
    },
    {
      kind: 'belongsTo',
      name: 'tasAssistance',
      type: 'tas-assistance',
      options: { async: false, inverse: null },
    },
  ],
});

export default TasPaymentAssistanceRecordSchema;
